import { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import AppRouter from "./components/AppRouter";
import NavBar from './components/NavBar'
import Footer from './components/Footer'
import './utils/styles/styles.css'
import { Spinner } from "react-bootstrap";

function App() {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
       setLoading(false);
  }, []); 

  if (loading) {
    return <Spinner animation="grow"/>
  }

  return (
    <BrowserRouter className="main-container">
      <NavBar />
      <div className="content">
        <AppRouter />
        {loading === true ? '' : <Footer/>}
      </div>
    </BrowserRouter>
  );
}
export default App